/**
 * Created by olga on 01.08.2025
 */

const Smile = function (getSmiles, options) {
    options = options || {};
    this.getSmiles = getSmiles;
    this.interval = options.interval || cleverapps.parseInterval("5 seconds");
    this.probability = options.probability || 0.5;
};

Smile.prototype.start = function (immediately) {
    this.stop();

    const timeout = immediately ? 0 : this.interval;
    this.smileTimeout = cleverapps.timeouts.setTimeout(() => {
        let toSmile;
        if (Math.random() < this.probability) {
            toSmile = PseudoRandom.GET("smile").choose(this.getSmiles() || []);
        }

        if (toSmile) {
            toSmile.smile();
        }

        this.start();
    }, timeout);
};

Smile.prototype.stop = function () {
    if (this.smileTimeout) {
        cleverapps.timeouts.clearTimeout(this.smileTimeout);
        this.smileTimeout = undefined;
    }
};

Smile.Interval = "5 seconds";